import React from 'react';
import { css } from 'aphrodite/no-important';
import VideoPlayerShare from '../videoPlayer/components/VideoShare';
import { styles } from './styles/pinVideoDetailsStyles'
import Viewport from '../../assets/components/fsUtils/Viewports';
import {decodeHtmlEntities} from '../shared/utils';

class PinVideoDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            title: decodeHtmlEntities(this.props.data.title),
            category: this.props.data.categoryName.replace(/-/g, ' '),
        };
        this.viewport = new Viewport();
    }

    componentDidMount() {
        if(this.viewport.isMobile) {
            let charMax = 50;
            let title = this.state.title;
            if(title.length >= charMax) {
                this.setState(() => ({
                    title: title.substr(0, charMax) + '...'
                }));
            }
        }
    }

    render() {
        let category = decodeURI(this.state.category);
        return (
            <div>
                <div className={css(styles.headline)}>
                    <h1> {this.state.title} </h1>
                </div>
                <div className={css(styles.byline)}>
                    { this.props.data.pubDate && <span className={'pub-date'}> {this.props.data.pubDate} </span> }
                    { this.state.category && <span className={css([styles.hideOnMobile, styles.uppercase])}> | {category} </span> }
                    { this.props.data.duration &&  <span className={css(styles.hideOnMobile)}> | Duration: {this.props.data.duration} </span> }
                </div>
                <div className={css(styles.hideOnMobile)}>
                    <VideoPlayerShare title={this.state.title} videoUrl={this.props.data.url} utmTerm={"pinned"}/>
                </div> 
            </div>
        );
    }
}

export default PinVideoDetails


// WEBPACK FOOTER //
// ./react-app-src/pinVideoDetails/PinVideoDetails.js